import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const ClockIcon = React.memo(function ClockIcon(props: TClockIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Clock" {...props}>
            <path d="M11 1.375C5.68477 1.375 1.375 5.68477 1.375 11C1.375 16.3152 5.68477 20.625 11 20.625C16.3152 20.625 20.625 16.3152 20.625 11C20.625 5.68477 16.3152 1.375 11 1.375ZM11 18.9922C6.58711 18.9922 3.00781 15.4129 3.00781 11C3.00781 6.58711 6.58711 3.00781 11 3.00781C15.4129 3.00781 18.9922 6.58711 18.9922 11C18.9922 15.4129 15.4129 18.9922 11 18.9922Z" />
            <path d="M14.7533 13.7199L11.6896 11.5049V6.1875C11.6896 6.09297 11.6123 6.01563 11.5178 6.01563H10.4844C10.3898 6.01563 10.3125 6.09297 10.3125 6.1875V12.1043C10.3125 12.1601 10.3383 12.2117 10.3834 12.2439L13.9369 14.8349C14.0142 14.8908 14.1217 14.8736 14.1775 14.7984L14.792 13.9605C14.8478 13.881 14.8307 13.7736 14.7533 13.7199Z" />
        </IconBase>
    );
});

export default ClockIcon;

// #region Types

export type TClockIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <ClockIcon /> : { ...IconBaseExample, render: ClockIcon };

// #endregion
